import { listGalleries } from '@wix/ambassador-progallery-v1-gallery/http';
import { State } from '@wix/ambassador-progallery-v1-gallery/types';
export const fetchProGalleryIds = async httpClient => {
  try {
    var _firstResponse$data, _firstResponse$data$g;
    const LIMIT = 10;
    const firstResponse = await httpClient.request(listGalleries({
      fields: ['id'],
      limit: LIMIT,
      offset: 0,
      state: State.SAVED
    }));
    const totalGalleries = ((_firstResponse$data = firstResponse.data) == null ? void 0 : _firstResponse$data.totalGalleriesCount) ?? 0;
    const firstBatchIds = ((_firstResponse$data$g = firstResponse.data.galleries) == null ? void 0 : _firstResponse$data$g.map(gallery => gallery.id ?? '')) ?? [];
    if (totalGalleries <= LIMIT) {
      return firstBatchIds;
    }
    const remainingGalleries = totalGalleries - LIMIT;
    const totalCalls = Math.ceil(remainingGalleries / LIMIT);
    const requests = [];
    for (let i = 0; i < totalCalls; i++) {
      requests.push(httpClient.request(listGalleries({
        fields: ['id'],
        limit: LIMIT,
        offset: LIMIT * (i + 1),
        state: State.SAVED
      })));
    }
    const responses = await Promise.all(requests);
    const restOfIds = responses.flatMap(_ref => {
      var _data$galleries;
      let {
        data
      } = _ref;
      return ((_data$galleries = data.galleries) == null ? void 0 : _data$galleries.map(gallery => gallery.id ?? '')) ?? [];
    });
    return [...firstBatchIds, ...restOfIds];
  } catch (error) {
    return [];
  }
};
//# sourceMappingURL=fetch-pro-gallery-ids.js.map